import { FC } from 'react';

import { MensagemErro } from '../../Formulario/MensagemErro/MensagemErro';
import { BotaoCancelar, BotaoSalvar } from '../../Botao/BotoesComuns';
import { NotasAvaliacaoField } from '../NotasAvaliacaoField';

import { Editor } from '../../Editor/Editor';
import { Formulario } from '../../Formulario/Formulario';
import { OperacaoFormularioCRUD } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import { MensagensErroServidor } from '../../MensagensErroServidor/MensagensErroServidor';
import * as Yup from 'yup';

import styled from 'styled-components';
import { FormikDebug } from '../../Formulario/FormikDebug';
import { useSelector } from 'react-redux';
import { AvaliacaoSelector } from 'store/Avaliacao/Avaliacao.selector';

const Schema = Yup.object().shape({
  notaAvaliacao: Yup.string().required().label("Nota da Avaliação"),
  // Comentário é opcional
  // comentario: Yup.string().required().label("Comentário"),
});

export interface AvaliacaoCamposFormulario {
  notaAvaliacao: string,
  comentario: string|undefined
}

interface AvaliacaoFormularioProps {
  onSubmit: (formulario: AvaliacaoCamposFormulario) => void;
  onClose: () => void
}

export const AvaliacaoFormulario: FC<AvaliacaoFormularioProps> = ({onSubmit, onClose}) => {
  const erros = useSelector(AvaliacaoSelector.formulario.erros);
  const formik = {
    initialValues: {
      notaAvaliacao: undefined,
      comentario: undefined
    },
    validationSchema: Schema,
    onSubmit: onSubmit
  };

  return <Formulario
    formik={formik}
    operacao={OperacaoFormularioCRUD.Criar}
  >
    <MensagensErroServidor erro={erros} />
    <FormikDebug />

    <NotaFieldset>
      <legend className="label">Como você classifica o atendimento prestado? (1 - mínimo, 10 - máximo)</legend>
      <NotasAvaliacaoField name="notaAvaliacao" />
      <MensagemErro name="notaAvaliacao" />
    </NotaFieldset>

    <label htmlFor="comentario">Gostaria de comentar algo sobre a solicitação atendida?</label>
    <Editor name="comentario" id="comentario" />
    <MensagemErro name="comentario" />

    <footer>
      <BotaoSalvar textoOnLoading="Salvando avaliação">Avaliar</BotaoSalvar>
      <BotaoCancelar type="button" onClick={onClose} />
    </footer>
  </Formulario>;
}

const NotaFieldset = styled.fieldset`
  display: flex;
  align-items: center;
  flex-direction: column;
`;